const _ = require("lodash");
const {DEFAULT_TRIAL_XP} = require("../TrainerCore");
const LabUtil = require("../LabUtil");

const settings = {
	infiniteAttempts: true,
	limitAttemptSpeed: true,
	neverGiveUp: true,
	hasNoSummary: false,
	canReplayProblem: true,
	starProgressType: "lab",
};

const initialize = function(result, processor) {
	return _.omit(result, [
		"starCutoffs",
		"starsAvailable",
		"botOutcomes",
		"setNumber",
	]);
};

const getStars = function(result) {
	return 0;
};

const getTrialXP = function(result) {
	if (result.isFirst) return DEFAULT_TRIAL_XP;
	else return 0;
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

// This is the same as the default function (don't need to export)
const getPercentComplete = function(result) {
	return (
		result.problems.filter(p => p.outcome === "correct").length /
		result.problems.length
	);
};

const getStarProgressInfo = function(result) {
	return {
		styleType: result.styleType,
		filledAmount: getPercentComplete(result),
		totalAmount: 1,
		celestialID: result.celestialID,
		celestialEarned: result.isComplete,
	};
};

// Returns the summary view to use and any data to pass to it.
const getSummaryInfo = function(result) {
	const celestialData = LabUtil.getCelestialFromID(result.celestialID);
	return {
		viewType: "lab",
		data: celestialData,
	};
};

const getLastAvailableIndex = function(result) {
	const problemUnlockType = result.problemUnlockType;
	if (!result.problems || !result.problems.length) {
		return 0;
	}
	if (problemUnlockType === "puzzle-standard") {
		const numCompleted = result.problems.filter(p => p.outcome).length;
		const numCorrect = result.problems.filter(p => p.outcome === "correct")
			.length;
		return Math.min(numCompleted + numCorrect, result.problems.length - 1);
	}
	if (problemUnlockType === "all") {
		return result.problems.length - 1;
	}
	// problemUnlockType === "sequential"
	let index = _.findIndex(result.problems, p => !p.outcome);
	if (index < 0) {
		index = result.problems.length - 1;
	}
	return Math.min(Math.max(index, 0), result.problems.length - 1);
};

module.exports = {
	settings,
	initialize,
	getStars,
	getTrialXP,
	getSetProgressInfo,
	getStarProgressInfo,
	getSummaryInfo,
	getLastAvailableIndex,
};
